export const loadState = () => {
  try {
    const serializedState =
      typeof window !== 'undefined'
        ? window.sessionStorage.getItem('disserto_user')
        : undefined;
    if (serializedState == null) {
      return undefined;
    }
    const authentication = {
      authentication: {
        loggedIn: true,
        user: JSON.parse(serializedState),
      },
    };
    return authentication;
  } catch (err) {
    console.log('ERROR ' + err);
    return undefined;
  }
};



// WEBPACK FOOTER //
// ./src/utils/sessionStorage.js